import { render, staticRenderFns } from "./ConfettiCross.vue?vue&type=template&id=22179ad0&lang=pug&"
import script from "./ConfettiCross.vue?vue&type=script&lang=js&"
export * from "./ConfettiCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports